var rich_content_viewer_default = {
  "fontElementMap": "ckcwm",
  "wrapper": "JAMWI",
  "pluginContainerMobile": "YbCf-",
  "viewer": "GyHmw",
  "android": "mFGop",
  "rootedTraversedContent": "Z6kW2",
  "atomic": "C0dH3",
  "toolbar": "E-4n1",
  "block": "-IqLP"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
